module.exports = __webpack_public_path__ + "static/media/hamantash1.4ba0deb3.png";